// import esEs from './es-es.yml';
// import enEn from './en-en.yml';
import esEs from "./es-es.json";
import enEn from  "./en-en.json";

export default {
	"en-en": true,
	"es-es": true
}



// WEBPACK FOOTER //
// ./i18n/available.js